import * as classnames from 'classnames/bind'
import * as React from 'react'
import { ChangeEvent, FC, FormEvent, useEffect, useRef, useState } from 'react'
import { isEmpty } from 'lodash'
import { MdSearch } from 'react-icons/md'
import styles from './search_field.module.scss'

const cx = classnames.bind(styles)
const SearchField: FC<{
  className?: string
  disabled?: boolean
  id: string
  labelClassName?: string
  name: string
  placeholder?: string
  required?: boolean
  value: string
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
  onChange?: (keyword: string) => void
  onFocus?: (e: ChangeEvent<HTMLInputElement>) => void
  onSubmit?: (keyword: string) => void
}> = ({
  className,
  disabled = false,
  id,
  name,
  labelClassName,
  placeholder,
  required = false,
  value,
  onBlur,
  onChange,
  onFocus,
  onSubmit
}) => {
  const [isFocused, setFocusInput] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (isEmpty(value)) {
      inputRef.current.value = ''
    }
  }, [])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      const { value } = e.target
      const keyword = isEmpty(value) ? '' : value
      onChange(keyword)
    }
  }

  const handleFocus = (e: ChangeEvent<HTMLInputElement>) => {
    setFocusInput(true)

    if (onFocus) {
      onFocus(e)
    }
  }

  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    setFocusInput(false)

    if (onBlur) {
      onBlur(e)
    }
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (onSubmit) {
      const { value } = e.currentTarget[`${name}`]
      const keyword = isEmpty(value) ? '' : value
      onSubmit(keyword)
    }
  }

  return (
    <div className={styles.searchField}>
      <form onSubmit={handleSubmit}>
        <input
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          className={cx(className, styles.formControl)}
          disabled={disabled}
          id={id}
          name={name}
          placeholder={placeholder}
          ref={inputRef}
          required={required}
          type="search"
          defaultValue={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
          onFocus={(e: ChangeEvent<HTMLInputElement>) => handleFocus(e)}
          onBlur={(e: ChangeEvent<HTMLInputElement>) => handleBlur(e)}
        />
        <label
          className={cx(labelClassName, styles.label, {
            labelDefault: !isFocused,
            labelFocused: isFocused
          })}
          htmlFor={id}
        >
          <MdSearch size={24} />
        </label>
      </form>
    </div>
  )
}

export default SearchField
